import { render, staticRenderFns } from "./RegisterOcr.vue?vue&type=template&id=6bc93b89&"
import script from "./RegisterOcr.vue?vue&type=script&lang=js&"
export * from "./RegisterOcr.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOcr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports